const shader = `
float getProjFactor(float fov, float screenHeight, float distance) {
    float projFactor = 1.0 / tan(fov / 2.0);
    projFactor /= distance;
    projFactor *= screenHeight / 2.0;
    return projFactor;
}
`;

export default shader;